import './photo-feed-card';

import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

import challengeData from '../helpers/state/challenge-data';
import { detectMobileViewport } from '../helpers/device';

/**
 * Challenge Photo Feed Component
 * 
 * Reusable component for displaying challenge photo feeds
 */
@customElement('challenge-photo-feed')
export class ChallengePhotoFeed extends LitElement {

    @property({ type: Boolean })
    loading: boolean = false;

    @property({ type: String })
    errorMessage?: string;

    @property({ type: Number })
    columns: number = 3;

    // use firstUpdate to set columns
    firstUpdated() {
        const queryString = new URLSearchParams(window.location.search);
        const columnsStr = queryString.get('columns');
        if (columnsStr) {
            const cols = parseInt(columnsStr, 10);
            if (!isNaN(cols) && cols >= 1 && cols <= 4) {
                this.columns = cols;
            }
        } else {
            this.columns = detectMobileViewport() ? 1 : 3;
        }
    }

    render() {
        if (this.loading) {
            return html`
                <div class="loading">
                    <div class="spinner"></div>
                    <p>Loading photos...</p>
                </div>
            `;
        }

        if (this.errorMessage) {
            return html`
                <div class="error">
                    <p>${this.errorMessage}</p>
                </div>
            `;
        }

        return html`
            <h2>Photo Feed</h2>
            <div class="photo-feed" style="grid-template-columns: repeat(${this.columns}, 1fr);">
                ${challengeData.allPublicChallengeImages.map((image) => html`
                    <photo-feed-card .photoDetails=${image}></photo-feed-card>
                `)}
            </div>
            ${challengeData.allPublicChallengeImages.length === 0 ? html`
                <p>No photos yet!</p>
            ` : ''}
        `;
    }

    static styles = css`
        :host {
            display: block;
            font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
        }

        .loading,
        .error {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            min-height: 300px;
            padding: 2rem;
        }

        .spinner {
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #3498db;
            border-radius: 50%;
            animation: spin 1s linear infinite;
        }

        @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
        }

        .error {
            color: #e74c3c;
        }

        .photo-feed-container {
            display: flex;
            flex-direction: column;
        }

        .photo-feed {
            display: grid;
            gap: 1rem;
            padding: 0;
        }

        .no-data {
            text-align: center;
            padding: 3rem;
            color: #999;
            font-size: 1.1rem;
        }

        /* Responsive adjustments */
        @media (max-width: 768px) {
            .photo-feed {
                grid-template-columns: repeat(2, 1fr) !important;
            }
        }

        @media (max-width: 480px) {
            .photo-feed {
                grid-template-columns: 1fr !important;
            }
        }
    `;
}
